import React from 'react';
import FetchComponent from './FetchComponent';

const App = () => {
  return (
    <div>
      <FetchComponent />
    </div>
  );
};

export default App;